import React from "react";
import { useUpsellWidgetModel } from "../../../hooks/useUpsellWidgetModelContext";

export const ReferralCodeInput = ({ register }) => {
    const model = useUpsellWidgetModel();
    return <div className={model.isPromo ? " col-md-6 upsell-form-right" : "col-md-12"}>
        <div className="form-group">
            <input
                className="form-control"
                type="text"
                placeholder="Referral Code"
                {...register("referralCode")}
            />
        </div>
    </div>;
};